import { SortType } from '../Sort';
export class AlphaSort {
    constructor(field, order) {
        this._field = field;
        this._order = order;
    }
    get type() {
        return SortType.ALPHA;
    }
    get field() {
        return this._field;
    }
    get order() {
        return this._order;
    }
}
